import { routes } from 'ogp/Routes';
import { useSearchParams } from 'react-router-dom';

const { queryParams } = routes.FlexPools;

export const useWorkersPoolDetail = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const open = (id: string) => {
    setSearchParams(
      (searchParams) => {
        searchParams.set(queryParams.WORKERS_POOL_ID, id);
        return searchParams;
      },
      {
        replace: true,
      }
    );
  };

  const close = () => {
    setSearchParams(
      (searchParams) => {
        searchParams.delete(queryParams.WORKERS_POOL_ID);
        return searchParams;
      },
      {
        replace: true,
      }
    );
  };

  return { id: searchParams.get(queryParams.WORKERS_POOL_ID), open, close };
};
